// extracted by css-extract-rspack-plugin
export default {"title":"title-gIrKKy","type":"type-f8lCp1 text-xs-medium","id":"id-mwgv90","note":"note-QRpOCn text-sm","sectionTitle":"sectionTitle-ICIDiZ","sectionError":"sectionError-bDwjFO"};